<template>
  <b-container>
    <h1>Person</h1>

    <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>
    
    <b-row>
      <b-col md="12">
        <b-button to="/person/add" variant="primary" v-if="$store.getters.notInRole('User')">Add</b-button>

        <b-form inline class="my-3" @submit.prevent>
            <b-input placeholder="Id No" id="idNo" class="mr-2" v-model.number="filterForm.idNo"></b-input>
            <b-input placeholder="Name" class="mr-2" v-model="filterForm.name"></b-input>
            <b-select :options="departments" value-field="id" text-field="name" class="mr-2" v-model="filterForm.departmentId">
                <template v-slot:first>
                    <b-select-option :value="null"></b-select-option>
                </template>
            </b-select>
            <b-select :options="companies" value-field="id" text-field="name" class="mr-2" v-model="filterForm.companyId">
                <template v-slot:first>
                    <b-select-option :value="null"></b-select-option>
                </template>
            </b-select>

            <b-button @click="filterClick">Filter</b-button>
            
            <a href="#" @click.prevent="excelClick" class="ml-2"><img width="30" src="/icon_excel.png" ></a>
        </b-form>

        <b-table class="mt-2" :fields="fields" :items="persons">
          <template v-slot:cell(idNo)="data">
            {{ data.value || '' }}
          </template>
          <template v-slot:cell(actions)="data">
            <div class="float-right">
            <b-button size="sm" variant="outline-secondary" class="mr-2" :to="`/person/${data.item.id}`">
              <b-icon-card-text></b-icon-card-text>
            </b-button>
            <b-button v-if="$store.getters.notInRole('User')" size="sm" variant="outline-secondary" @click="showDeleteDlg(data.item)"><b-icon-trash></b-icon-trash></b-button>
            </div>
          </template>
        </b-table>

        <ul class="pagination">
          <li class="page-item" :class="{ disabled: filterForm.page === 1 }"><a class="page-link" href="#" @click.prevent="prevPage">Previous</a></li>
          <li class="page-item" :class="{ disabled: filterForm.page >= totalPages }"><a class="page-link" href="#" @click.prevent="nextPage">Next</a></li>
        </ul>
      </b-col>
    </b-row>

    <b-modal 
      title="Confirm Delete" 
      v-model="deleteDialog"
      ok-variant="danger"
      ok-title="Delete"
      @ok="deletePerson"
    >
      <p>Delete {{ deleteItem.name }}?</p>
    </b-modal>
  </b-container>
</template>
<script>import axios from 'axios';

export default {
  data() {
    return {
      fields: ['idNo', 'firstName', 'lastName', 'department', 'company', { key: 'actions', label: '' }],
      persons: [],
      companies: [],
      departments: [],
      deleteDialog: false,
      deleteItem: {},
      error: '',
      filterForm: {
          idNo: '',
          name: '',
          departmentId: null,
          companyId: null,
          page: 1
      },
      totalPages: 1
    }
  },
  methods: {
    showDeleteDlg(item) {
      this.error = '';
      this.deleteItem = item;
      this.deleteDialog = true;
    },
    deletePerson() {
      axios.delete(`/api/persons/${this.deleteItem.id}`)
      .then(() => {
        const index = this.persons.indexOf(this.deleteItem);
        if (index > -1) {
          this.persons.splice(index, 1);
        }
      })
      .catch(() => {
        this.error = 'Failed to delete person.'
      })
    },
    excelClick() {
      const url = new URL('/api/persons/excel');
      const params = new URLSearchParams(url.search);
      
      params.append('idNo', this.filterForm.idNo);
      params.append('name', this.filterForm.name);
      params.append('companyId', this.filterForm.companyId || '');
      params.append('departmentId', this.filterForm.departmentId || '');

      window.location.href = `${url}?${params}`;
    },
    filterClick() {
      this.filterForm.page = 1;
      this.filter();
    },
    filter() {
      this.error = '';
      
      axios.get('/api/persons', { params: this.filterForm })
      .then(res => { 
        this.persons = res.data.result
        this.filterForm.page = res.data.page;
        this.totalPages = res.data.totalPages;
      })
      .catch(() => { this.error = 'Failed to filter data' });
    },
    nextPage() {
      this.filterForm.page++;
      this.filter();
    },
    prevPage() {
      this.filterForm.page--;
      this.filter();
    }
  },
  created() {
    const personQuery = axios.get('/api/persons');
    const companyQuery = axios.get('/api/companies');
    const departmentQuery = axios.get('/api/departments');
    
    Promise.all([personQuery, companyQuery, departmentQuery])
    .then(res => {
      this.persons = res[0].data.result;
      this.totalPages = res[0].data.totalPages;
      this.companies = res[1].data;
      this.departments = res[2].data;
    })
    .catch(() => {
        this.error = 'Failed to load data';
    });
  }
}
</script>

<style scoped>
    #idNo {
        width: 70px;;
    }
</style>